import {
  FormControl,
  FormHelperText,
  // InputLabel,
  MenuItem,
} from '@mui/material';
import { FieldAttributes, getIn } from 'formik';
import React from 'react';
import CustomerCareSelect from './CustomerCareSelect';

interface CCDropdownFormProps {
  field: { name: string; onBlur(): void; onChange(): void; value: string };
  form: FieldAttributes<any>;
  label: string;
  options: any[];
  extra: { children: any; label: string; margin: string; placeHolder: string };
  useNewStyles?: boolean;
}

function CCDropdownForm(props: CCDropdownFormProps) {
  const { field, form, label, options, useNewStyles, ...extra } = props;
  const errorText = getIn(form.errors, field.name);

  return (
    <FormControl variant="outlined" fullWidth error={!!errorText}>
      <CustomerCareSelect label={label} {...field} {...extra}>
        {options.map((op) => (
          <MenuItem key={op.value} value={op.value}>
            {op.icon && <span style={{ marginRight: 8 }}>{op.icon}</span>}
            {op.label}
          </MenuItem>
        ))}
      </CustomerCareSelect>
      <FormHelperText>{errorText}</FormHelperText>
    </FormControl>
  );
}

export default CCDropdownForm;
